const TRUSTED_DEVICE_KEY = 'airmaxx_trusted_device';

const getLocalToken = () => {
  return localStorage.getItem('token');
};

const getLocalRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

const updateLocalTokens = (token, refreshToken) => {
  localStorage.setItem('token', token);
  localStorage.setItem('refreshToken', refreshToken);
};

const removeTokens = () => {
  // Preserve trusted device token for 2FA
  const trustedDevice = localStorage.getItem(TRUSTED_DEVICE_KEY);
  localStorage.clear();
  if (trustedDevice) {
    localStorage.setItem(TRUSTED_DEVICE_KEY, trustedDevice);
  }
};

const tokenServices = {
  getLocalToken,
  getLocalRefreshToken,
  updateLocalTokens,
  removeTokens,
};

export default tokenServices;
